import { FC } from 'react';

import { Title } from '@nebo-team-dev/vobaza.ui.title/dist';
import { Button } from '@nebo-team-dev/vobaza.ui.button/dist';
import ModalLayout from '../../../src/hoc/withModal';

import styles from 'global/styles/modules/inline-modal.module.scss';

interface Props {
  title?: string;
  description?: string;
  onClose?: () => void;
}

const CartItemChangeModal: FC<Props> = ({ description, title, onClose }) => {
  return (
    <ModalLayout onClose={onClose}>
      <div className={styles.inlineModal} data-modal>
        <div className={styles.inlineModalContent}>
          <Title element="h2" className={styles.inlineModalTitle}>
            {title || 'Количество товаров к корзине изменилось'}
          </Title>
          <p className={styles.inlineModalText}>
            {description || 'Некоторые товары более не доступны и удалены из корзины'}
          </p>
          <Button
            className={styles.inlineModalItem}
            text="Продолжить покупки"
            size="big"
            isFullScreen
            onClick={onClose}
          />
        </div>
      </div>
    </ModalLayout>
  );
};
export default CartItemChangeModal;
